import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ProfileSubpage from 'Views/Page/Content/Templates/Profile/Templates/ProfileSubpage';
import fr from 'facet-rest';
import { stripeNonSecretKey } from 'Consts/keys';
import {
  Elements,
  StripeProvider,
} from 'react-stripe-elements';
import AddCreditCardForm
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/AddPaymentMethodProfileSubpage/AddCreditCardForm';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { root } from '../subpageClasses';

const useStyles = buildUseStyles('AddPaymentMethodProfileSubpageContent', (theme) => ({
  root: root(theme),
}));

const AddPaymentMethodProfileSubpageContent = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { loadPageContentLink } = usePageContentContext();
  const previousPageRelationship = resource.relationship(fr.relationships.previousPage.name);

  return (
    <ProfileSubpage
      className={classNames(classes.root, className)}
      title={resource.attr('title')}
      description={resource.attr('subTitle')}
      backLabel={previousPageRelationship?.meta('prompt')}
      backLink={previousPageRelationship?.link('related')}
    >
      <StripeProvider apiKey={stripeNonSecretKey}>
        <Elements>
          <AddCreditCardForm onSuccess={() => loadPageContentLink(previousPageRelationship?.link('related'))} />
        </Elements>
      </StripeProvider>
    </ProfileSubpage>
  );
};

AddPaymentMethodProfileSubpageContent.defaultProps = {
  className: '',
};

AddPaymentMethodProfileSubpageContent.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AddPaymentMethodProfileSubpageContent;
